module.exports = __webpack_public_path__ + "img/image2.151dd3d8.png";